import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeAppData } from "./store/data-action";
// import { initializeAppData } from "./store/data-actiondev";
import "./styles/css/normalize.css";
import "./styles/css/webflow.css";
import "./styles/css/global_tabclix.css";
import MyRoutes from "./components/MyRoutes";
import track from "react-tracking";
import { fetchAuth } from "./api/tabclixContentApi";
import { getTabclixCode } from "./helpers/embed-code";
import { useCallback } from "react";
import Navbar from "./layout/Navbar";
import PageApp from "./layout/PageApp";


/**
 * Highest component in the hierarchy
 */
function App() {
  const currentPage = useSelector((state) => state.datareducer.currentPage);
  // const allData = useSelector((state) => state.datareducer.AllData)
  // const nav = useSelector(state => state.datareducer.navBar);
  const dispatch = useDispatch();



  /**
   * React toolkit also accepts actions creators that return function.
   * If it sees that you dispatch an action which is actually a function,
   * it will execute that function for you
   *
   * @param {none}
   *
   */
 

  const dispatchInitializeAppData = useCallback(() => {
    dispatch(initializeAppData());
  }, [dispatch]);
  
  useEffect(() => {
    dispatchInitializeAppData();
  }, [dispatchInitializeAppData]);


const MemoizedPageApp = React.memo(PageApp);


  return (
    <>
    <MyRoutes />
    <main>
    {currentPage && <MemoizedPageApp />}
      <Navbar />
    </main>
  </>
  );
}

let code = getTabclixCode();

const TrackedApp = track(
  // app-level tracking data
  { TbxAnalyticsSourceApp: `${code }`},
  // { TbxAnalyticsSourceApp: `tab`},

  // top-level options
  {
    // custom dispatch to console.log in addition to pushing to dataLayer[]
    dispatch:  async(data) => {
      try {
       

        const authToken = await fetchAuth()

        const url = `${process.env.REACT_APP_CMS_URL}/api/analytics`;
        const mydata = data;
        const axios = require('axios');
        axios.post(url, mydata, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'userID': code,
            'Authorization': `Bearer ${authToken}`,
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  }
)(App);

export default TrackedApp;
